
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"124","height":"124"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"124","height":"124","fill":"#400F3F","rx":"16"}}),_c('path',{attrs:{"fill":"#FF4702","d":"M60.94 78.56l12.453-12.453a5.166 5.166 0 001.524-3.668V38.75a5.168 5.168 0 00-5.167-5.167H41.333a5.167 5.167 0 00-5.166 5.167v36.167a5.166 5.166 0 005.166 5.166h15.94a5.165 5.165 0 003.668-1.524zm-4.107-13.977A2.584 2.584 0 0159.417 62h10.798L56.833 75.382V64.583zm23.25-20.666v36.166a5.166 5.166 0 01-5.166 5.167H46.5a5.167 5.167 0 005.167 5.167h23.25c5.707 0 10.333-4.627 10.333-10.334v-31a5.166 5.166 0 00-5.167-5.166z"}})])])
          )
        }
      }
    